import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
export default defineComponent({
    name: 'CreatePassword',
    setup() {
        const password = ref('');
        const confirmPassword = ref('');
        const errorMessage = ref('');
        const router = useRouter();
        const handleLogin = () => {
            if (!password.value || !confirmPassword.value) {
                errorMessage.value = 'Please fill in both password fields.';
                return;
            }
            if (password.value !== confirmPassword.value) {
                errorMessage.value = 'Passwords do not match.';
                return;
            }
            router.push('/admin');
        };
        return {
            password,
            confirmPassword,
            errorMessage,
            handleLogin
        };
    }
});
